// ===== 98黑料 首页展示用 Mock 数据（仅供静态展示）=====

export const navLinks = [
  { key: "flash", label: "快讯流", href: "#flash" },
  { key: "timeline", label: "时间线", href: "#timeline" },
  { key: "collection", label: "黑料合集", href: "#collection" },
  { key: "summary", label: "汇总整理", href: "#summary" },
  { key: "guide", label: "避雷指南", href: "#guide" },
  { key: "talk", label: "大家说", href: "#talk" },
];

export const heroKeywords = ["黑料合集", "汇总帖", "整理清单", "时间线整理", "避雷指南"];

export const hotSections = ["主播红人", "艺人圈", "游戏电竞", "饭圈塌房", "品牌翻车", "探店测评"];

// ===== 配图（封面驱动，统一为暖红 / 奶油色编辑画报风，均为硬编码字面量）=====
export const heroCover =
  "https://readdy.ai/api/search-image?query=editorial%20news%20magazine%20cover%20art%20of%20a%20torn%20newspaper%20archive%20with%20red%20redaction%20tape%20and%20clipped%20evidence%20fragments%20pinned%20on%20a%20warm%20cream%20studio%20board%2C%20vintage%20crimson%20and%20amber%20palette%2C%20dramatic%20soft%20key%20light%2C%20subtle%20grain%2C%20editorial%20high%20detail%2C%20no%20text&width=900&height=1200&seq=hero-98-2026&orientation=portrait";

export const coverSpotlight =
  "https://readdy.ai/api/search-image?query=empty%20concert%20spotlight%20beam%20falling%20on%20an%20empty%20stage%20with%20folding%20chairs%2C%20warm%20amber%20and%20crimson%20haze%2C%20dramatic%20single%20light%20source%2C%20cinematic%20editorial%20photography%2C%20subtle%20film%20grain%2C%20clean%20cream%20halo%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-spotlight&orientation=landscape";

export const coverChat =
  "https://readdy.ai/api/search-image?query=overhead%20shot%20of%20mismatched%20smartphones%20with%20bright%20screens%20on%20a%20warm%20cream%20desk%2C%20red%20and%20amber%20screen%20glow%2C%20digital%20chaos%20and%20notifications%20mood%2C%20editorial%20flat%20lay%20photography%2C%20warm%20cinematic%20tones%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-chat&orientation=landscape";

export const coverGame =
  "https://readdy.ai/api/search-image?query=analog%20game%20controller%20abandoned%20on%20warm%20cream%20background%20with%20red%20neon%20glow%20and%20scattered%20arcade%20tokens%2C%20editorial%20still%20life%2C%20vintage%20crimson%20palette%2C%20soft%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-game&orientation=landscape";

export const coverBrand =
  "https://readdy.ai/api/search-image?query=stacked%20product%20boxes%20with%20a%20broken%20glass%20jar%20on%20warm%20cream%20background%2C%20crimson%20and%20amber%20studio%20lighting%2C%20editorial%20product%20photography%20with%20dramatic%20shadows%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-brand&orientation=landscape";

export const coverReply =
  "https://readdy.ai/api/search-image?query=retro%20pager%20and%20payphone%20with%20coiled%20cable%20on%20cream%20table%2C%20warm%20crimson%20backlight%2C%20editorial%20object%20photography%2C%20vintage%20reporting%20mood%2C%20soft%20grain%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-reply&orientation=landscape";

export const coverTime =
  "https://readdy.ai/api/search-image?query=stacks%20of%20vintage%20newspapers%20and%20printed%20contact%20sheets%20with%20a%20red%20paperclip%20on%20warm%20cream%20table%2C%20editorial%20archive%20photography%2C%20amber%20task%20lighting%2C%20dramatic%20shadows%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-time&orientation=landscape";

export const coverFan =
  "https://readdy.ai/api/search-image?query=rows%20of%20empty%20fansite%20banners%20and%20light%20sticks%20lined%20against%20a%20warm%20cream%20wall%2C%20crimson%20and%20amber%20mood%20lighting%2C%20editorial%20documentary%20photography%2C%20soft%20grain%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-fan&orientation=landscape";

export const coverShop =
  "https://readdy.ai/api/search-image?query=open%20food%20delivery%20bags%20and%20camera%20phone%20on%20a%20checkerboard%20table%2C%20warm%20crimson%20and%20amber%20studio%20lighting%2C%20editorial%20food%20review%20photography%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-shop&orientation=landscape";

export const coverEvidence =
  "https://readdy.ai/api/search-image?query=closed%20investigation%20folder%20with%20yellow%20sticky%20notes%20and%20a%20red%20lens%20on%20warm%20cream%20desk%2C%20editorial%20reporting%20photography%2C%20amber%20desk%20lamp%20light%2C%20dramatic%20shadow%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-evidence&orientation=landscape";

export const coverRadio =
  "https://readdy.ai/api/search-image?query=vintage%20radio%20and%20magnetic%20tapes%20on%20a%20warm%20cream%20shelf%20with%20crimson%20glow%2C%20editorial%20object%20photography%2C%20amber%20task%20lighting%2C%20soft%20grain%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-radio&orientation=landscape";

export const coverStreet =
  "https://readdy.ai/api/search-image?query=empty%20night%20street%20with%20warm%20amber%20streetlights%20and%20crimson%20signage%20bokeh%2C%20editorial%20urban%20photography%2C%20lonely%20curb%20mood%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-street&orientation=landscape";

export const coverMoney =
  "https://readdy.ai/api/search-image?query=fanned%20playing%20cards%20and%20coin%20stack%20on%20warm%20cream%20background%2C%20crimson%20and%20amber%20studio%20light%2C%20editorial%20still%20life%20photography%2C%20dramatic%20shadow%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-money&orientation=landscape";

export const coverLens =
  "https://readdy.ai/api/search-image?query=press%20camera%20with%20long%20lens%20pointed%20at%20blurred%20crowd%20behind%20frosted%20glass%2C%20warm%20amber%20light%2C%20editorial%20journalism%20photography%2C%20soft%20grain%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-lens&orientation=landscape";

export const coverCensor =
  "https://readdy.ai/api/search-image?query=black%20marker%20and%20red%20tape%20over%20a%20typed%20document%20on%20warm%20cream%20table%2C%20editorial%20archive%20photography%2C%20crimson%20and%20amber%20tones%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=cover-2026-censor&orientation=landscape";

// ===== 快讯流（顶部速递，封面驱动）=====
export const flashItems = [
  {
    id: "f1",
    tag: "主播红人",
    time: "38分钟前",
    heat: 92,
    cover: coverSpotlight,
    title: "头部带货主播深夜开播回应合约风波，弹幕当场炸开",
    excerpt: "复盘整场回应：哪些是实锤、哪些仍是留白，时间线已同步归档，欢迎在评论区补瓜。",
    comments: 1284,
  },
  {
    id: "f2",
    tag: "饭圈塌房",
    time: "2小时前",
    heat: 88,
    cover: coverFan,
    title: "某男团成员被扒旧站运营细节，凌晨冲上讨论热榜",
    excerpt: "旧物料、粉丝会账目与后援会分工全被翻出，整理了值得重点看的四条线索。",
    comments: 976,
  },
  {
    id: "f3",
    tag: "游戏电竞",
    time: "5小时前",
    heat: 76,
    cover: coverGame,
    title: "解说转会背后现对赌疑云，多个战队账号已删除相关博",
    excerpt: "从官宣公告反推时间差，把战队口径与个人说法逐句对照做成了一张表。",
    comments: 643,
  },
  {
    id: "f4",
    tag: "品牌翻车",
    time: "昨天",
    heat: 71,
    cover: coverBrand,
    title: "咖啡品牌联名周边被指偷工减料，客服口径前后矛盾",
    excerpt: "首批收货反馈与宣传图差异明显，整理了一组同机位对比截图供自行判断。",
    comments: 521,
  },
];

// ===== 时间线（单起重点事件脉络）=====
export const timelineItems = [
  {
    time: "9.02 · 晚间",
    type: "起",
    title: "旧帖被翻出，预热开始",
    desc: "一位老粉在整理清单里扒到三年前的高楼帖，关键字开始被批量转载。",
  },
  {
    time: "9.03 · 下午",
    type: "发酵",
    title: "商务页被扒出排期异常",
    desc: "多家合作方页面先后清空排期，评论区开始自行归纳疑点并互相补课。",
  },
  {
    time: "9.04 · 深夜",
    type: "回应",
    title: "工作室发出首份声明",
    desc: "声明措辞被逐段拆解，避雷指南小组把其中的时间空档单独标记出来。",
  },
  {
    time: "9.05 · 上午",
    type: "反转",
    title: "原帖作者现身补充证据",
    desc: "补充了聊天记录与付款流水截图，时间线整理更新至当前最新节点。",
  },
  {
    time: "9.06 · 现在",
    type: "观望",
    title: "等待第二轮说法",
    desc: "各方暂未进一步回应，本时间线保持更新，欢迎在讨论区同步新线索。",
  },
];

export const timelineMarks = ["起", "发酵", "回应", "反转", "观望"];

// ===== 黑料合集（分类卡阵，封面驱动）=====
export const collectionItems = [
  {
    id: "c1",
    section: "主播红人",
    cover: coverChat,
    title: "「人设前后不一」合集",
    summary: "把多场直播里对同一件事的不同说法并排列出，标注每处口径漂移的时间点。",
    tags: ["口径漂移", "截图对照", "持续更新"],
    heat: 96,
    updated: "3小时前更新",
    comments: 2104,
  },
  {
    id: "c2",
    section: "游戏电竞",
    cover: coverMoney,
    title: "「商务对赌」整理清单",
    summary: "转会与对赌相关黑料按金额、时间、出处汇总成表，附原始链接备案。",
    tags: ["账目", "合同", "待实锤"],
    heat: 89,
    updated: "昨天更新",
    comments: 1287,
  },
  {
    id: "c3",
    section: "艺人圈",
    cover: coverLens,
    title: "「旧账被翻」汇总帖",
    summary: "早年被删博、旧采访逐条找回，整理成一篇可按时间跳转的长帖索引。",
    tags: ["旧物料", "索引", "补课向"],
    heat: 84,
    updated: "1天前更新",
    comments: 1560,
  },
  {
    id: "c4",
    section: "饭圈塌房",
    cover: coverRadio,
    title: "「粉丝会账目」疑点合集",
    summary: "周边定价、应援支出与后援会明细对不上账的几处，均已截图归档。",
    tags: ["账目透明", "应援", "整理中"],
    heat: 78,
    updated: "2天前更新",
    comments: 903,
  },
  {
    id: "c5",
    section: "品牌翻车",
    cover: coverEvidence,
    title: "「宣传与实物不符」清单",
    summary: "联名周边货不对板的案例做成一站式避雷手册，附同机位对比。",
    tags: ["实物对比", "避雷", "可回溯"],
    heat: 73,
    updated: "2天前更新",
    comments: 764,
  },
  {
    id: "c6",
    section: "探店测评",
    cover: coverShop,
    title: "「充值好评」暗访整理",
    summary: "把疑似剧本探店、买量好评的样本整理成册，标注可信度等级。",
    tags: ["探店", "暗访", "提醒向"],
    heat: 68,
    updated: "3天前更新",
    comments: 652,
  },
];

export const collectionFilter = ["全部", "主播红人", "游戏电竞", "艺人圈", "饭圈塌房", "品牌翻车", "探店测评"];

// ===== 汇总帖 / 整理清单 =====
export const summaryGroups = [
  {
    id: "s1",
    no: "清单 01",
    type: "避雷手册",
    cover: coverCensor,
    title: "本月新增避雷清单",
    meta: "涵盖 12 个主体 · 36 条要点",
    excerpt: "把本月新增与翻新的避雷要点归拢成一张表：涉及主体、核心争议、当前状态都并列可查。",
    points: ["已核实 9 条", "待补充 3 条", "可一键跳转到对应合集"],
  },
  {
    id: "s2",
    no: "汇总 02",
    type: "时间线整理",
    cover: coverTime,
    title: "2026 上半年事件时间线总表",
    meta: "覆盖 6 大板块 · 41 个节点",
    excerpt: "把半年里的重点瓜点按日排序，从起爆到回应的每个节点都有原帖留档与跳转。",
    points: ["41 个关键节点", "全部标注出处", "支持按板块筛选"],
  },
  {
    id: "s3",
    no: "帖 03",
    type: "高楼索引",
    cover: coverStreet,
    title: "三年来讨论度最高的补课楼",
    meta: "共 8 座高楼 · 累计 12w+ 楼",
    excerpt: "热度常年霸榜的高楼帖，现按主题、规模、活跃度重新整理，方便新同学从楼顶读到楼底。",
    points: ["8 座经典高楼", "按活跃度排序", "每楼附内容摘要"],
  },
];

// ===== 避雷指南 =====
export const guideDo = [
  { key: "1", title: "先看时间线，再下结论", desc: "事件几乎都是层层发酵的。先按时间线整理补齐前因，才不会被断章取义带偏。", tag: "入门第一步" },
  { key: "2", title: "认准一手来源", desc: "能回到原帖、原视频的，别停留在二手的转述帖，逐字核对才能分清实锤与猜测。", tag: "进阶习惯" },
  { key: "3", title: "为实锤分级", desc: "截图、录屏、官方声明属于高可信；聊天转述与匿名爆料要单独标注「待实锤」。", tag: "核心方法" },
  { key: "4", title: "警惕塌房式反向带节奏", desc: "声明越晚、删得越勤，越该保持冷静，等第二轮说法出现再站队也不迟。", tag: "老手提醒" },
];

export const guideStats = [
  { value: "8.6", label: "补课完成度（平均）" },
  { value: "6", label: "覆盖板块" },
  { value: "41", label: "已归档节点" },
  { value: "2.1w+", label: "讨论区累计楼" },
];

export const mythItems = [
  { myth: "「没有回应 = 默认」", truth: "沉默原因很多，别当成默认结论，交给时间线与后续证据。" },
  { myth: "「图多 = 一定真」", truth: "图可以裁剪、顺序可以调，关键要看完整上下文是否连贯。" },
  { myth: "「楼高 = 一定准」", truth: "热度代表关注度高，不代表证据强，论据级别与楼高无关。" },
];

// ===== 社区讨论氛围 =====
export const comments = [
  {
    id: "cm1",
    name: "按时补课的阿九",
    badge: "楼主",
    tag: "主播红人",
    time: "12分钟前",
    content: "把工作室声明里被删掉的那段逐字比对了，逻辑链其实是能闭合的，建议都去看看完整录像。",
    likes: 342,
    replies: 58,
  },
  {
    id: "cm2",
    name: "不站队的路人甲",
    badge: "",
    tag: "饭圈塌房",
    time: "40分钟前",
    content: "这份避雷清单我收藏了，之前就是靠它躲过一次跟风。真希望这类整理能多一点。",
    likes: 211,
    replies: 23,
  },
  {
    id: "cm3",
    name: "考据派老油条",
    badge: "资深补课",
    tag: "游戏电竞",
    time: "1小时前",
    content: "时间线里那个时间空档我补了一条证据，发在下面了，大家看看合不合理。",
    likes: 188,
    replies: 41,
  },
  {
    id: "cm4",
    name: "只吃实锤的新人",
    badge: "",
    tag: "品牌翻车",
    time: "2小时前",
    content: "新来的，谢谢这份汇总帖，终于不用自己去翻十几页旧帖了，一站看明白。",
    likes: 97,
    replies: 12,
  },
];